import { dealEventLogControllerGetDealEventSendersOptions } from '@dealstack/shared/lib/backendClient/@tanstack/react-query.gen';
import { useDealEventPeopleFilter } from '@dealstack/frontend/app/pages/Project/DealEventLog/useDealEventPeopleFilter.ts';

const page = (
	data:
		| { senders?: { id: string; name?: string; email: string }[]; hasMore?: boolean }
		| undefined
) => ({
	people: data?.senders ?? [],
	hasMore: !!data?.hasMore,
});

const toValue = ({ id }: { id?: string }) => id ?? '';

/**
 * Senders read from the deal's own messages rather than from its current team: someone who has
 * since left still sent what the feed shows.
 */
export const useDealEventSenders = (dealId: string, enabled: boolean, selected?: string) =>
	useDealEventPeopleFilter({
		dealId,
		enabled,
		selected,
		queryOptions: dealEventLogControllerGetDealEventSendersOptions,
		page,
		toValue,
	});
